module.exports = __webpack_public_path__ + "img/logo_10.2f2dd5cd.png";